import { InlineAlertType } from '@varo/graphql-schema-types';
import { NativeStackHeaderProps, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { InlineAlert } from 'shared/components/vxl/InlineAlert/InlineAlert';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import theme from 'shared/styles/theme';

const SpendingLimitsScreen = () => {
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'learningCenter',
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          title: '',
          headerBackVisible: true,
          headerShown: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <ActionScreen
        visual="WALLET_A_ANIMATED"
        titleText={translatedText('spendingLimits.title')}
        titleTextStyle="extra-large"
        bodyContent={
          <View style={styles.bodyContainer}>
            <BodyBaseText>
              {translatedText('spendingLimits.description')}
            </BodyBaseText>
            <InlineAlert
              alertType={InlineAlertType.Brand}
              bodyText={translatedText(
                'spendingLimits.inLineAlert.description',
              )}
              iconKeyType="LIGHT_BULB"
              titleText={translatedText('spendingLimits.inLineAlert.title')}
            />
          </View>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    rowGap: theme.spacing.m,
  },
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default SpendingLimitsScreen;
